
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um/fyrirtaekid/fyrirtaekjaskra",
      function () {
        return require("private-next-pages/um/fyrirtaekid/fyrirtaekjaskra.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um/fyrirtaekid/fyrirtaekjaskra"])
      });
    }
  